"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Mapper_cache, _Mapper_hb, _SimpleMapper_hb;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleMapper = exports.Mapper = void 0;
const Handlebars = __importStar(require("handlebars"));
const crypto = __importStar(require("crypto"));
const lru_cache_1 = __importDefault(require("lru-cache"));
const Helpers_1 = require("./lib/Helpers");
class Mapper {
    /**
     * Initiates the LRU cache and also adds the helpers
     * @param max_cache_size
     */
    constructor(max_cache_size) {
        _Mapper_cache.set(this, void 0); // change any to handlebars
        _Mapper_hb.set(this, void 0); // for now
        if (!max_cache_size) {
            max_cache_size = 25;
        }
        __classPrivateFieldSet(this, _Mapper_cache, new lru_cache_1.default({ max: max_cache_size }), "f"); // might be too big
        Handlebars.registerHelper(Helpers_1.helpers);
        __classPrivateFieldSet(this, _Mapper_hb, (template) => Handlebars.compile(template), "f");
    }
    /**
     *
     * @param template - the handlebar string template
     * @param data - the data object that populates the template
     * @param [json_out] - whether the result should be transformed into json
     * @returns the transformed template string or the json object based on the template
     */
    compile(template, data, json_out) {
        // make the hash of the string, see if it is in the cache
        const cache_key = crypto.createHash('sha1').update(template).digest('base64');
        let cached_template = __classPrivateFieldGet(this, _Mapper_cache, "f").get(cache_key);
        if (!cached_template) {
            cached_template = __classPrivateFieldGet(this, _Mapper_hb, "f").call(this, template);
            __classPrivateFieldGet(this, _Mapper_cache, "f").set(cache_key, cached_template);
        }
        const result = cached_template(data); //?
        if (json_out) {
            try {
                return JSON.parse(result);
            }
            catch (e) {
                return result;
            }
        }
        else {
            return result;
        }
    }
}
exports.Mapper = Mapper;
_Mapper_cache = new WeakMap(), _Mapper_hb = new WeakMap();
class SimpleMapper {
    constructor() {
        _SimpleMapper_hb.set(this, void 0); // for now
        Handlebars.registerHelper(Helpers_1.helpers);
        __classPrivateFieldSet(this, _SimpleMapper_hb, (template) => Handlebars.compile(template), "f");
    }
    /**
     *
     * @param template - the handlebar string template
     * @param data - the data object that populates the template
     * @param [json_out] - whether the result should be transformed into json
     * @returns the transformed template string or the json object based on the template
     */
    compile(template, data, json_out) {
        // make the hash of the string, see if it is in the cache
        const compiled_template = __classPrivateFieldGet(this, _SimpleMapper_hb, "f").call(this, template);
        const result = compiled_template(data); //?
        if (json_out) {
            try {
                return JSON.parse(result);
            }
            catch (e) {
                return result;
            }
        }
        else {
            return result;
        }
    }
}
exports.SimpleMapper = SimpleMapper;
_SimpleMapper_hb = new WeakMap();
